import { useEffect } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthProvider";
import { useTheme } from "./ThemeProvider";

/** Load only the authenticated account's preference; never cache identity. */
export function AccountThemeSync() {
  const { session } = useAuth();
  const { setPreference, getRevision } = useTheme();
  const userId = session?.userId;
  useEffect(() => {
    if (!userId) return;
    const controller = new AbortController();
    const revision = getRevision();
    void api.get<{ saved: boolean; display_theme: "organization" | "light" | "dark" }>("/auth/preferences", controller.signal).then((value) => {
      if (controller.signal.aborted || !value.saved || revision !== getRevision()) return;
      setPreference(value.display_theme === "organization" ? "system" : value.display_theme);
    }).catch(() => { /* Keep the working device preference if settings are unavailable. */ });
    return () => controller.abort();
  }, [userId, setPreference, getRevision]);
  return null;
}
